import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IFeedback;

const feedbackSlice = createSlice({
    name: "feedback",
    initialState,
    reducers: {},
});

export const {} = feedbackSlice.actions;
export default feedbackSlice.reducer;

export const getFeedbackReducer = (state: RootState) => state.feedback;
